import { FormModel } from 'components/Form';
import { Validators } from 'utils/validators';

export const AddEditCorporateRateForm = (strings: any, assigneeList: any): FormModel[] => {
  return [
    {
      label: strings.validFrom,
      value: '',
      size: 'medium',
      type: 'date',
      variant: 'outlined',
      placeholder: '',
      field: 'validFrom',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6 },
      required: true,
    },
    {
      label: strings.validto,
      value: '',
      size: 'medium',
      type: 'date',
      variant: 'outlined',
      placeholder: '',
      field: 'validTo',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6 },
      required: true,
    },
    {
      label: strings.issuedBy,
      value: '',
      size: 'medium',
      type: 'drop-down',
      variant: 'outlined',
      placeholder: '',
      field: 'issuedBy',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6 },
      required: true,
      options: assigneeList,
    },
    {
      label: '',
      value: '',
      type: 'section',
      placeholder: '',
      field: '',
      autoFocus: true,
      validators: [],
      required: false,
      responsive: { xs: 12, sm: 12 },
    },
  ];
};
